<div class="custom-file" [class]="class">
    <input id="file" type="file" class="custom-file-input" (change)="changeFile($event)" [accept]="extensionAccepted" />
    <label class="custom-file-label" for="file" #label data-testid="btn-select-csv-file">{{
        file ? file.name : "Selecione um arquivo"
        }}

        <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="label.click()">Selecionar</button>
    </label>
</div>